import { confirmDeleteProperty } from '../effects/confirmDeleteProperty';
import { IGetState, TBoardId, TCustomPropertyId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';

export const onConfirmDelete = (
    boardId: TBoardId,
    customPropertyId: TCustomPropertyId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(confirmDeleteProperty(boardId, customPropertyId));
    };
    return action;
};
